import { message } from 'antd';
import { AxiosInstance } from 'axios';

import User from '@/model/General/User';
import { PackageMessage } from '@/model/Logistic/PackageMessage';
import { ShippingLabel } from '@/model/Logistic/ShippingLabel/ShippingLabel';

import PackageApi from './PackageApi';

class PackageRepository {
  packageApi: PackageApi;

  constructor(axiosInstance: AxiosInstance) {
    this.packageApi = new PackageApi(axiosInstance);
  }

  /**
   * Metadata: transforma los campos receiver_* del formulario en el payload de direcciones guardadas.
   */
  saveNewAddress = async packageData => {
    const shippingLabel: ShippingLabel = {
      address: packageData.receiver_address,
      email: packageData.receiver_email,
      phone_number: packageData.receiver_phone,
      localidad: packageData.receiver_localidad,
      postal_code: packageData.receiver_postal_code,
      company: packageData.company,
      contact: packageData.receiver_name,

      description: `${packageData.receiver_address} - ${packageData.receiver_name} - ${packageData.receiver_phone} - ${packageData.receiver_email}`,
    };

    try {
      const response = await this.packageApi.createAddress(shippingLabel);

      return response.data;
    } catch (error) {
      console.error('Error saving address:', error);
      throw error;
    }
  };

  printShippingLabel(packageId: number, resource?: string, params?: Record<string, unknown>) {
    return this.packageApi
      .printShippingLabel(packageId, resource, params)

      .then(() => message.success('Etiqueta de envío generada correctamente'))
      .catch(() => message.error('Error al generar la etiqueta de envío'));
  }

  getMessages = async (packageId: number) => {
    try {
      const messages: PackageMessage[] = await this.packageApi.getMessages(packageId);
      const messagesData: PackageMessage[] = messages.map(msg => ({
        ...msg,
        origin_user_data:
          typeof msg.origin_user_data === 'number'
            ? msg.origin_user_data
            : new User(msg.origin_user_data),
      }));

      return messagesData;
    } catch (error) {
      message.error('Error al obtener los mensajes');
      throw error;
    }
  };

  postMessage = async (packageId: number, packageMessage: PackageMessage) => {
    try {
      const response = await this.packageApi.postMessage(packageId, packageMessage);

      return response.data;
    } catch (error) {
      message.error('Error al enviar el mensaje');
      throw error;
    }
  };

  getLocationFromCEP = async (postalCode: string) => {
    try {
      const response = await this.packageApi.getLocationFromCEP(postalCode);
      const { city, street } = response;
      const { provincia } = city;

      return {
        ciudad: city,
        provincia: provincia,
        direccion: street,
      };
    } catch (error) {
      console.error('Error fetching location from CEP:', error);
      throw error;
    }
  };
}

export default PackageRepository;
